import React from "react";
import {Button, Grid} from "@mui/material";
import {SaveProfile} from "../../../export/components/EnhancedProfile";
import {useHistory} from "react-router";
import {SaveDialog} from "../../../../../files/import_export_profiles";
import EnhancedSaveDialog from "../../../export/components/Dialogs/EnhancedSaveDialog";
import type {RemoteProfile} from "../profile_helpers";

// region TypeScript Interfaces
interface NavigationButtonsProps {
    allowBack: () => boolean;
    allowNext: () => boolean;
    backStep: () => void;
    nextStep: () => void;
    onBack?: () => boolean | void;
    onNext?: () => boolean | void;
    profileType: string;
    formattedProfile: RemoteProfile;
    loading?: boolean;
    activeStep?: number;
    steps?: unknown;
}
// endregion

export default function NavigationButtons(props: NavigationButtonsProps) {
    const {allowBack, allowNext} = props;
    const {backStep, nextStep} = props;
    const {onBack, onNext} = props;

    const {profileType, formattedProfile} = props;

    const history = useHistory();

    const [saveDialogOpen, setSaveDialogOpen] = React.useState(false);

    return (
        <Grid container justifyContent={"flex-end"} style={{width: "100%", gap: "5px"}}>
            <Button variant="outlined" disabled={allowBack() === false} style={{justifySelf: "flex-end"}} onClick={() => setSaveDialogOpen(true)}>
                Save & Exit
            </Button>
            <Button variant="outlined" disabled={allowBack() === false} style={{justifySelf: "flex-end"}}
                onClick={() => {
                    if(onBack) {
                        let returnCode = onBack();
                        if(returnCode === false) return;
                    }
                    (SaveProfile as any)(formattedProfile, profileType);
                    backStep();
                }}
            >
                Back
            </Button>
            <Button variant="contained" color="primary" disabled={allowNext() === false || props.loading} style={{justifySelf: "flex-end"}}
                onClick={() => {
                    if(onNext) {
                        let returnCode = onNext();
                        if(returnCode === false) return;
                    }
                    (SaveProfile as any)(formattedProfile, profileType);
                    nextStep();
                }}
            >
                Continue
            </Button>
            {(SaveDialog as any) && <SaveDialog open={saveDialogOpen} profileType={profileType} values={formattedProfile}
                        onClose={() => setSaveDialogOpen(false)}
                        onSave={async () => {
                            await new Promise(r => setTimeout(r, 750));
                            setSaveDialogOpen(false);
                            history.push("/productonboardingcenter/catalog");
                        }}
                        template={(props: any) => <EnhancedSaveDialog {...props} />}
            />}
        </Grid>
    );
}
